document.addEventListener("DOMContentLoaded", function () {
    let today = new Date().toLocaleString('en-US', { weekday: 'long' });

    document.querySelectorAll(".announcement-bar").forEach(block => {
        let allowedDays = block.getAttribute("data-days");

        // console.log("Today is:", today);
        // console.log("Block allowed days:", allowedDays);

        if (!allowedDays.includes(today)) {
            block.style.display = "none";  // Hide block if today is not allowed
        //     console.log("Hiding block:", block);
        // } else {
        //     console.log("Showing block:", block);
        }
    });
});
